<template>
  <q-dialog v-model="showDialog" persistent>
    <q-card style="min-width: 400px; border-radius: 20px; padding: 10px;">
      <q-card-section>
        <div class="text-h6 text-weight-bold">Update verfügbar</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div class="text-body2 text-grey-7">
          Wir laden nun die aktuelle WAWICAN Version für Sie. Vielen Dank! Sie können sofort normal weiterarbeiten.
        </div>
      </q-card-section>

      <q-card-actions align="center">
        <q-btn 
          style="border-radius: 20px; padding: 10px;"
          label="Jetzt neu laden"
          color="primary" 
          unelevated
          @click="onReload"
        />
        <q-btn 
          style="border-radius: 20px; padding: 10px;"
          label="In 1 Minute erneut erinnern" 
          color="primary" 
          outline
          @click="onRemindLater"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UpdateModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'reload', 'remind-later'],
  computed: {
    showDialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    onReload() {
      this.$emit('reload')
      this.showDialog = false
    },
    onRemindLater() {
      this.$emit('remind-later')
      this.showDialog = false
    }
  }
})
</script>
